import React from "react";
import "./MainAdminPage.sass";
import Window from "../../_containers/window/Window";
import ButtonComponent from "../../_components/common/buttons/ButtonComponent";
import {useNavigate} from "react-router";
import {
    ADD_TEACHER_PAGE, COLLABORATION_REQUEST_ADMIN_PAGE,
    REQUEST_ADMIN_PAGE,
    STATISTIC_PAGE,
    STUDENT_ADMIN_PAGE,
    TEACHER_ADMIN_PAGE
} from "../../common/links";

export default function MainAdminPage() {
    const navigate = useNavigate();

    return (
        <Window>
            <fieldset className="MainAdminPage-fieldset">
                <legend>Заявки на курсы</legend>
                <ButtonComponent onClick={() => navigate(REQUEST_ADMIN_PAGE)}>
                    Новые заявки на курсы
                </ButtonComponent>
                <ButtonComponent onClick={() => navigate(COLLABORATION_REQUEST_ADMIN_PAGE)}>
                    Новые заявки на сотрудничество
                </ButtonComponent>
            </fieldset>
            <fieldset className="MainAdminPage-fieldset">
                <legend>Учителя</legend>
                <ButtonComponent onClick={() => navigate(TEACHER_ADMIN_PAGE)}>
                    Список учителей
                </ButtonComponent>
                <ButtonComponent onClick={() => navigate(ADD_TEACHER_PAGE)}>
                    Добавить учителя
                </ButtonComponent>
            </fieldset>
            <fieldset className="MainAdminPage-fieldset">
                <legend>Ученики</legend>
                <ButtonComponent onClick={() => navigate(STUDENT_ADMIN_PAGE)}>
                    Список учеников
                </ButtonComponent>
                <ButtonComponent>Добавить ученика</ButtonComponent>
            </fieldset>
            <fieldset className="MainAdminPage-fieldset">
                <legend>Курсы</legend>
                <ButtonComponent>Добавить курс</ButtonComponent>
            </fieldset>
            <ButtonComponent onClick={() => navigate(STATISTIC_PAGE)}>
                Статистика
            </ButtonComponent>
        </Window>
    )
}